import { UserAgentApplication } from 'msal';

const LOGIN_SCOPES = ["openid", "profile", "user.read"];/*, "Report.Read.All"];*/
const API_URL = "api://d3feb07a-7210-43ad-aa5b-917dd9f49eaf"; // Replace with the new Application ID
const API_SCOPES = ["api://d3feb07a-7210-43ad-aa5b-917dd9f49eaf/Users.Read"]; // Replace with the new Application ID

const acquireToken = (permissions, silent = true, reportToken = false) => {
    var userRequest = {
        scopes: API_SCOPES
    };

    if (reportToken) {
        userRequest.scopes = ["https://analysis.windows.net/powerbi/api/Report.Read.All"];
    }
    else if (permissions) {
        userRequest.scopes = [...permissions.map(permission => `${API_URL}/${permission}`)];
    }

    try {
        if (silent) {
            return msalApp.acquireTokenSilent(userRequest);
        }
        else {
            return msalApp.acquireTokenPopup(userRequest);
        }
    }
    catch (error) {
        console.log("Error", error);
    }
};

export const makeCall = (callback) => {
    if (typeof callback === 'function') {
        const ls = require('local-storage');
        const permissions = ls('user-permissions');

        const handleCallback = response => {
            callback({ 'Authorization': `Bearer ${response.accessToken}` });
        };

        acquireToken(permissions)
            .then(handleCallback)
            .catch(err => {
                //acquireTokenSilent fail, popup login
                if (err.name === 'ClientAuthError') {
                    // login the user
                    ls('redirect-path', window.location.pathname);

                    msalApp.loginRedirect(LOGIN_SCOPES)
                        .then(loginResponse => {
                            acquireToken(permissions)
                                .then(handleCallback)
                                .catch(error => console.log('auth popup token error', error));
                        })
                        .catch(error => {
                            acquireToken(permissions)
                                .then(handleCallback)
                                .catch(error => console.log('error token popup', error));
                        });
                }
                else {
                    // try to get the token by popping up

                    console.error('error', err.name, err);

                    acquireToken(permissions, false)
                        .then(handleCallback)
                        .catch(error => console.log('error token popup', error));
                }
            });
    }
};

export const getEmbedToken = (callback) => {
    if (typeof callback === 'function') {

        const handleCallback = response => {
            callback(response.accessToken);
        };

        acquireToken(null, true, true)
            .then(handleCallback)
            .catch(err => {
                //acquireTokenSilent fail, popup login
                if (err.name === 'ClientAuthError') {
                    // login the user
                    msalApp.loginPopup(LOGIN_SCOPES)
                        .then(loginResponse => {
                            acquireToken(null, true, true)
                                .then(handleCallback)
                                .catch(error => console.log('auth popup token error', error));
                        })
                        .catch(error => {
                            acquireToken(null, true, true)
                                .then(handleCallback)
                                .catch(error => console.log('error token popup', error));
                        });
                }
                else {
                    // try to get the token by popping up

                    console.error('error', err.name, err);

                    acquireToken(null, false, true)
                        .then(handleCallback)
                        .catch(error => console.log('error token popup', error));
                }
            });
    }
};

const msalApp = new UserAgentApplication({
    auth: {
        clientId: "d3feb07a-7210-43ad-aa5b-917dd9f49eaf", // Replace with the new Application ID
        authority: "https://login.microsoftonline.com/15cb6c53-0a50-4876-a66c-9a753d760a7d",
        validateAuthority: true,
        postLogoutRedirectUri: `${window.location.origin}`,
        navigateToLoginRequestUrl: false, /* Don't change this! */
        redirectUri: `${window.location.origin}/aad-callback` // Add this to the new app registration
    },
    cache: {
        cacheLocation: "localStorage",
        storeAuthStateInCookie: false
    }
});




// WEBPACK FOOTER //
// ./src/auth-utils.js